<script setup lang="ts">
    import {ref} from 'vue';
    import ChatPlateSearch from './ChatPlateSearch.vue';
    import ChatVinSearch from './ChatVinSearch.vue';

    defineProps<{disabled: boolean}>();

    const emit = defineEmits<{
        (event: 'search-plate', plate: string): void;
        (event: 'search-vin', vin: string): void;
    }>();

    // Same c-search-tabs markup/classes as the site's own kenteken-or-VIN widget
    // (resources/views/partials/home/carsearch.blade.php) - style.css already ships it.
    const activeTab = ref<'plate' | 'vin'>('plate');
</script>

<template>
    <div class="panel panel-default panel-body">
        <div class="c-search-tabs__nav">
            <button
                type="button"
                class="c-search-tabs__tab"
                :class="{'is-active': activeTab === 'plate'}"
                @click="activeTab = 'plate'">
                <i
                    class="fa fa-car"
                    style="margin-right: 3px"></i>Kenteken
            </button>
            <button
                type="button"
                class="c-search-tabs__tab"
                :class="{'is-active': activeTab === 'vin'}"
                @click="activeTab = 'vin'">
                <i
                    class="fa fa-hashtag"
                    style="margin-right: 3px"></i>Chassisnummer
            </button>
        </div>

        <div
            v-if="activeTab === 'plate'"
            class="c-search-tabs__panel is-active">
            <ChatPlateSearch
                :disabled="disabled"
                @search="(plate) => emit('search-plate', plate)" />
        </div>

        <div
            v-else
            class="c-search-tabs__panel is-active">
            <ChatVinSearch
                :disabled="disabled"
                @search="(vin) => emit('search-vin', vin)" />
        </div>
    </div>
</template>
